

















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import EventDetailCard from "@/components/EventDetailCard.vue";
import { VibrixEventRegistration } from "@/interfaces/vibrixEventRegistration";
import { EventService } from "@/services/eventService";
import { PublicVibrixEvent } from "@/interfaces/vibrixEvent";

@Component({ components: { EventDetailCard } })
export default class EventJoin extends Vue {
    @Prop() public registrationId!: string;

    public loading: boolean = false;
    public joining: boolean = false;

    public registration: VibrixEventRegistration | null = null;
    public event: PublicVibrixEvent | null = null;

    public currentTime: number = Date.now();
    public randomWaitBeforeJoin = Math.random() * 15000;

    public get progress() {
        const oneHour = 1000 * 60 * 60;
        return ((oneHour - this.remainingTime) / oneHour) * 100;
    }

    public get startTime() {
        if (!this.event) {
            return 0;
        }
        return new Date(this.event.start_time).getTime();
    }

    public get remainingTime() {
        if (!this.event) {
            return 0;
        }
        return new Date(this.event.start_time).getTime() - this.currentTime;
    }

    public get remainingTimeFormated() {
        const time = new Date(this.remainingTime);
        return `${time
            .getUTCHours()
            .toString()
            .padStart(2, "0")}:${time
            .getUTCMinutes()
            .toString()
            .padStart(2, "0")}:${time
            .getUTCSeconds()
            .toString()
            .padStart(2, "0")}`;
    }

    public get remainingDays() {
        const time = new Date(this.remainingTime);
        return time.getUTCDate() - 1;
    }

    public mounted() {
        setInterval(() => (this.currentTime = Date.now()), 250);
    }

    @Watch("registrationId", { immediate: true })
    public async loadRegistration(registrationId: string) {
        this.loading = true;
        try {
            this.registration = await EventService.getEventRegistration(
                registrationId
            );
        } finally {
            this.loading = false;
        }
    }

    @Watch("registration.event_id")
    public async loadEvent(eventId: string) {
        this.loading = true;
        try {
            this.event = await EventService.getEventByIdPublic(eventId);
            this.$nextTick(() => {
                if (this.remainingTime > 0) {
                    setTimeout(
                        () => this.joinEvent(),
                        this.remainingTime - this.randomWaitBeforeJoin
                    );
                }
                if (
                    this.remainingTime < 0 &&
                    this.event &&
                    new Date(this.event.end_time).getTime() > this.currentTime
                ) {
                    this.joinEvent();
                }
            });
        } finally {
            this.loading = false;
        }
    }

    public async joinEvent() {
        if (this.event && this.registration) {
            this.joining = true;
            const valid = await EventService.getIsRegistrationValid(
                this.event.id,
                this.registration.signupMeta.email
            );
            if (!valid) {
                this.$store.commit("showSnackbar", {
                    color: "error",
                    text: this.$t("event.blocklistBlocked"),
                });
                this.joining = false;

                return;
            }
            await EventService.updateRegistration(this.registrationId);
            const studioId = this.event.studio_id;
            this.$router.replace(`/studio/${studioId}/${this.registrationId}`);
        }
    }
}
